import { useState } from 'react'

import { EMPTY_FUNCTION, EMPTY_OBJECT } from '../../../../constants/common'
import { GretaAIChatChatActionType } from '../../GretaAIChat.constants'

export function useGretaAIChatChatActions({
  activeChatId,
  chatListLoader,
  discardChatDraft,
  forgetChat = EMPTY_FUNCTION,
  setActiveChatId,
} = EMPTY_OBJECT) {
  const [chatAction, setChatAction] = useState(null)

  function openRenameChat(chat) {
    setChatAction({ chat, type: GretaAIChatChatActionType.Rename })
  }

  function openDeleteChat(chat) {
    setChatAction({ chat, type: GretaAIChatChatActionType.Delete })
  }

  function closeChatAction() {
    setChatAction(null)
  }

  function startNewChat() {
    setActiveChatId(null)
  }

  async function confirmRenameChat(title) {
    const { id } = chatAction.chat
    const isActiveChat = id === activeChatId

    const isChatKept = await chatListLoader.renameChat(id, title.trim())

    if (!isChatKept && isActiveChat) {
      setActiveChatId(null)
    }

    closeChatAction()
  }

  async function confirmDeleteChat() {
    const { id } = chatAction.chat
    const isActiveChat = id === activeChatId

    closeChatAction()

    // Clear selection + draft only after the delete commits; a rollback keeps them.
    if (await chatListLoader.removeChat(id)) {
      if (isActiveChat) {
        setActiveChatId(null)
      }

      discardChatDraft(id)
      forgetChat(id)
    }
  }

  return {
    chatAction,
    closeChatAction,
    confirmDeleteChat,
    confirmRenameChat,
    openDeleteChat,
    openRenameChat,
    startNewChat,
  }
}
